"use client";

type PublishUpdateInfoProps = {
  publishedOn: string;
  updatedOn: string;
  showPublished?: boolean;
};
export default function publishon({
  publishedOn,
  updatedOn,
  showPublished = true
}: PublishUpdateInfoProps) {
  return <div className="flex items-center gap-6">
      {/* Published */}
      {showPublished && <div className="flex items-center gap-1">
          <span className="text-12-tamil-300 text-1B1B1B">Published On :</span>
          <span className="text-12-tamil-500 text-1B1B1B">{publishedOn}</span>
        </div>}

      {/* Updated */}
      <div className="flex items-center gap-1">
        <span className="text-12-tamil-300 text-1B1B1B">Updated On :</span>
        <span className="text-12-tamil-500 text-1B1B1B">{updatedOn}</span>
      </div>
    </div>;
}